import * as React from 'react'

import {
  makeStyles,
  Combobox,
  Option,
  Text
} from '@fluentui/react-components'
import { HistoryFilled } from '@fluentui/react-icons'

import style from '../styles/search-box'

import FilterButton from './FilterButton'
import FilterPanel from './FilterPanel'
import SortMenuButton from './SortMenuButton'

const useStyles = makeStyles(style)

const SearchBox = (props) => {
  const {
    k2IdHistory,
    setK2IdInput,
    sortInput,
    setSortInput,
    filterInputs,
    setFilterInputs,
    onKeyDown,
    setError
  } = props

  const [isOpenFilterPanel, setIsOpenFilterPanel] = React.useState(false)
  const [matchingOptions, setMatchingOptions] = React.useState(k2IdHistory)

  const classes = useStyles()

  const onChange = (event) => {
    const value = event.target.value.trim()

    setError(null)

    const matches = k2IdHistory.filter(
      (option) => option.toLowerCase().indexOf(value.toLowerCase()) === 0
    )

    setMatchingOptions(matches)
    setK2IdInput(value)
  }

  const onOptionSelect = (event, data) => {
    const matchingOption = data.optionText && k2IdHistory.includes(data.optionText)

    if (matchingOption) {
      setK2IdInput(data.optionText)
    }
  }

  return (
    <>
      <div className={classes.searchBoxContainer}>
        <Combobox
          className={classes.searchBoxInput}
          placeholder='Enter K2 ID'
          freeform
          expandIcon={null}
          input={{ className: classes.searchBoxInput }}
          listbox={{ className: classes.listBox }}
          onChange={onChange}
          onOptionSelect={onOptionSelect}
          onKeyDown={onKeyDown}
        >
          {matchingOptions.map((item, index) => (
            <Option
              key={index}
              text={item}
            >
              <HistoryFilled />
              <Text>{item}</Text>
            </Option>
          ))}
        </Combobox>
        <FilterButton
          setIsOpenFilterPanel={setIsOpenFilterPanel}
        />
        <SortMenuButton
          sortInput={sortInput}
          setSortInput={setSortInput}
        />
      </div>
      {isOpenFilterPanel && (
        <FilterPanel
          filterInputs={filterInputs}
          setFilterInputs={setFilterInputs}
        />
      )}
    </>
  )
}

export default SearchBox
